import { RaisedButton } from "@evergis/ui";
import React, { FC, ReactNode, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDialogReset } from "../../../hooks/useDialogs";
import { useDialogWizardContext } from "../DialogComponents/DialogWizard/DialogWizardContext";
import { BackButton, CancelButton } from "../DialogComponents/styled";
import { StyledDialogActions } from "../SelectFiles/Edit/Table/styled";
import { StyledActionsGroup } from "./styled";

export type NewLayerStepActionsProps = {
  extraActions?: ReactNode;
  nextStepDisabled?: boolean;
  onNextStep?: VoidFunction;
  onPreviousStep?: VoidFunction;
  onCancel?: VoidFunction;
};

const NewLayerStepActions: FC<NewLayerStepActionsProps> = ({
  extraActions,
  nextStepDisabled,
  onPreviousStep,
  onNextStep,
  onCancel,
}) => {
  const { t } = useTranslation("common");
  const {
    step,
    onPreviousStep: onWizardPreviousStep,
    stepsCount,
    onNextStep: onWizardNextStep,
  } = useDialogWizardContext();
  const backButtonText = t("actions.back2");
  const applyText = step !== stepsCount ? t("actions.next") : t("actions.ready");
  const onApply = useCallback(async () => {
    onNextStep && (await onNextStep());
    onWizardNextStep();
  }, [onWizardNextStep, onNextStep]);
  const onBackButton = useCallback(async () => {
    onPreviousStep && (await onPreviousStep());
    onWizardPreviousStep();
  }, [onWizardPreviousStep, onPreviousStep]);
  const cancelDialog = useDialogReset();

  return (
    <StyledDialogActions>
      {extraActions}
      <StyledActionsGroup>
        <RaisedButton disabled={nextStepDisabled} onClick={onApply} primary>
          {applyText}
        </RaisedButton>
        {step > 0 && <BackButton onClick={onBackButton}>{backButtonText}</BackButton>}
        <CancelButton onClick={onCancel || cancelDialog}>{t("actions.cancel")}</CancelButton>
      </StyledActionsGroup>
    </StyledDialogActions>
  );
};

export default NewLayerStepActions;
